var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59098 4.38743L12.1127 6.9091M2 14.5L4.44852 14.0339C4.96768 13.9351 5.44513 13.6824 5.81882 13.3087L13.4558 5.67169C14.1814 4.94612 14.1814 3.76974 13.4558 3.04418C12.7303 2.31861 11.5539 2.31861 10.8283 3.04418L3.19131 10.6812C2.81761 11.0549 2.56493 11.5323 2.46611 12.0515L2 14.5Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit_icon.9c7c5e0b26a522610847aa3df3524361.svg";
export { ForwardRef as ReactComponent };